import { ButtonHTMLAttributes } from "react";

import { ButtonLibrasMenuContainer } from "./styles";

type LibrasButtonMenuProps = ButtonHTMLAttributes<HTMLButtonElement>;

export function LibrasButtonMenu(props: LibrasButtonMenuProps) {
  return (
    <ButtonLibrasMenuContainer className="button hint" data-hint="Sinalizar" data-hint-placement="top" type="button"  {...props} />
  );
}
